import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import sentImg from '../../../assets/images/confirmation_sent.png';
import { analyticsTrack } from '../../analyticsUtils';
import './EmptyFeaturedProfiles.scss';

class EmptyFeaturedProfiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSent: false,
    };
    this.handleAnalytics = this.handleAnalytics.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = target;
    const { name } = target;
    this.setState({ valid: target.validity.valid, [name]: value });
  }

  handleAnalytics() {
    this.setState({ emailSent: true });
    analyticsTrack('Clicked on Reach Out', { location: 'Featured Consultants' });
  }

  renderConnectButton() {
    const { userData, filters } = this.props;

    let baseLink = 'https://clora.na.chilipiper.com/book/search';
    if (userData) {
      baseLink += `?firstname=${userData.first_name}&lastname=${userData.last_name}&email=${userData.email}`;
      if (userData.company_name) {
        baseLink += `&current_last_company_name__c=${userData.company_name}`;
      }
    }
    if (Object.keys(filters).length) {
      baseLink += `${userData ? '&' : '?'}sales_intake_description__c=`;
      if (filters.aoe) { baseLink += `AOE-${filters.aoe}`; }
      if (filters.ta) { baseLink += `  TA-${filters.ta}`; }
      if (filters.therapy) { baseLink += `  THERAPY-${filters.therapy}`; }
    }

    return (
      <Button
        type="submit"
        name="commit"
        id="connect-employer-submit-btn"
        tabIndex="0"
        href={encodeURI(baseLink)}
        target="_blank"
        onClick={this.handleAnalytics}
      >
        Reach out to us!
      </Button>
    );
  }

  render() {
    const { searchError } = this.props;
    const { emailSent } = this.state;
    if (emailSent) {
      return (
        <div className="empty-featured-profiles emailSent">
          <img src={sentImg} className="email-sent-image" alt="email sent" />
          <h1 className="bold muted-gray-text">Thank you! Clora will contact you shortly!</h1>
        </div>
      );
    }
    return (
      <div className="empty-featured-profiles">
        { searchError
          ? <p className="body-text-1 error-text">{searchError}</p>
          : ''}
        <h2 className="bold">Clora has thousands more consultants in the network!</h2>
        <p className="body-text-1">
          Looks like you haven’t found what you’re looking for yet.
        </p>
        <p className="body-text-1">
          Connect with our team and we will help you find the right consultant for your project!
        </p>
        { this.renderConnectButton() }
      </div>
    );
  }
}

EmptyFeaturedProfiles.propTypes = {
  filters: PropTypes.shape({}),
  searchError: PropTypes.string,
  userData: PropTypes.shape({}),
};

EmptyFeaturedProfiles.defaultProps = {
  filters: {},
  userData: null,
  searchError: null,
};

export default EmptyFeaturedProfiles;
